import * as inversifyReact from "inversify-react";

export const useInjection = inversifyReact.useInjection;
